import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { BASE_AUTH_PATH } from "../paths";
import { SuccessScreen } from "@covertree/ui";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";

export default function CheckEmail() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const emailAddress = state.emailAddress;

  const navigateToLogin = useCallback(() => {
    navigate(BASE_AUTH_PATH);
  }, [navigate]);

  const description = (
    <Grid>
      <Typography
        mt={2}
        mb={4}
        variant="body1"
        sx={{
          color: "info.main",
        }}>
        We’ve sent an email to <strong>{emailAddress}</strong> with instructions
        to reset your password.
      </Typography>
      <Typography
        mt={2}
        mb={4}
        variant="body1"
        sx={{
          color: "info.main",
        }}>
        If you don’t see the email, be sure to check your <strong>spam</strong>{" "}
        or <strong>junk</strong> folder.
      </Typography>
    </Grid>
  );

  return (
    <SuccessScreen
      title="Email sent!"
      maxWidth="xs"
      description={description}
      buttonLabel="Continue to login"
      action={navigateToLogin}
    />
  );
}
